/* eslint-disable no-undef */
import React from 'react';
import { ChevronLeft } from '@mui/icons-material';
import { PostNavigationLink, PurpleColor } from './PostNavigation.styled';
import { useBackButtonParams } from '@core/constants/backButtonNavigation';

export type PreviousPage = 'all assignments' | 'feed';

export type PostNavigationProps = Readonly<{
  href: string;
  onClick?: React.MouseEventHandler;
  style?: React.CSSProperties;
  prevPage: PreviousPage;
}>;

const PostNavigation = ({
  style = {},
  href,
  onClick,
  prevPage,
}: PostNavigationProps) => {
  // Check for back button params is there or not. Back button params only shows if webAppFtHeaderNavigationMode112025 flag is true
  const params = useBackButtonParams();
  const updatedHref = params ? `${href}${params}` : href;

  return (
    <PostNavigationLink to={updatedHref} style={style} onClick={onClick}>
      <ChevronLeft htmlColor={PurpleColor} />
      <span>Back to {prevPage}</span>
    </PostNavigationLink>
  );
};

export default PostNavigation;
